import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, lastValueFrom } from 'rxjs';
import { DbrApiService, DbrUserLoginDto } from '@balloon-race-fullstack-monorepo/dbr-rest-api';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private dbrApiService = inject(DbrApiService)
  public loginTrigger: BehaviorSubject<any> = new BehaviorSubject(null);

  public triggerLogin(): void {
    this.loginTrigger.next(1);
  }

  public reset(): void {
    localStorage.removeItem("access_token");
  }

  // generate token
  public async makeLogin(loginData: DbrUserLoginDto): Promise<boolean> {
    const signinResponse = await lastValueFrom(this.dbrApiService.authControllerSignIn({body: loginData}));
    localStorage.setItem("access_token", signinResponse.access_token);
    return true;
  }

  //isLogin: whether user is logged in or not
  public isLoggedIn() {
    const tokenStr = localStorage.getItem("access_token");
    return !(tokenStr == undefined || tokenStr == '' || tokenStr == null);
  }

  //logout: remove token_exam_portal from the local storage
  public logout() {
    localStorage.removeItem("access_token");
    localStorage.removeItem("user");
    return true;
  }

  //get token
  public getToken() {
    return localStorage.getItem("access_token");
  }

  //set user deatails
  // public setUser(user: any) {
    // localStorage.setItem('user', JSON.stringify(user));
  // }

  //get user
  // public getUser() {
  //   let userStr = localStorage.getItem("user");
  //   if (userStr != null) {
  //     return JSON.parse(userStr);
  //   }
  //   else {
  //     this.logout();
  //     return null;
  //   }
  // }

  // get user role
  // public getUserRole(){
  //   let user = this.getUser();
  //   return user.authorities[0].authority;// returns only first role
  // }
}
